import { render } from "./SocialMedia.vue?vue&type=template&id=07a2a920&scoped=true"
import script from "./SocialMedia.vue?vue&type=script&lang=js"
export * from "./SocialMedia.vue?vue&type=script&lang=js"

import "./SocialMedia.vue?vue&type=style&index=0&id=07a2a920&lang=sass&scoped=true"

import exportComponent from "/home/frappe/ONEFM_Landing_page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a2a920"]])

export default __exports__